module.exports = __webpack_public_path__ + "img/stock7.88b298b3.png";